import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import {
  BaseMovePayload,
  Distribution,
  MovePayloadWithItems
} from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class DistributionService {
  private baseUrl = environment.distributionApi;

  constructor(private http: HttpClient) {}

  public moveNextAll(body: BaseMovePayload): Observable<Distribution> {
    return this.http.post<Distribution>(`${this.baseUrl}/movenextall`, body);
  }

  public moveNext(body: MovePayloadWithItems): Observable<Distribution> {
    return this.http.post<Distribution>(`${this.baseUrl}/movenext`, body);
  }
}
